import { IPaginatedResponse } from "@/types/IPaginatedResponse";

export interface FormField {
  label: string;
  type: string;
  placeholder: string;
}

export enum IPaymentProviderType {
  InStoreCash = "in-store-cash",
  BankTransfer = "bank-transfer",
  OnlinePayment = "online-payment",
  Group = "group",
}

export interface IFeatureFlagLogType {
  active: boolean;
  disabled: boolean | null;
  title: string | null;
  banner: string | null;
  offer_extension?: boolean;
}

export interface IPaymentProvider {
  name: string;
  logo: string;
  displayName: string;
  toolTip?: string;
  tooltipPrefix?: string;
  tooltipSuffix?: string;
  bottomMessage?: string;
  country: string;
  order: number;
  type: IPaymentProviderType;
  showGrouped?: boolean;
  featureFlagStatus: IFeatureFlagLogType;
  highlight?: boolean;
  fee: number;
  maxAmount: number | null;
  minAmount: number | null;
  subtitle?: string;
  groupSectionTitle?: string;
  groupSectionSubtitle?: string;
  groupDrillTitle?: string;
}

export interface IPaymentProviderParams {
  country: string;
  paymentOption: string;
  /** When set, the backend blocks providers whose min/max the amount falls outside. */
  amount?: number | null;
  lang?: string;
}

export interface IPaymentProviderBackend {
  /**
   * This interface must match the backend response, the PaymentProviderSerializer
   */
  id: number;
  option_name: string;
  country: string;
  name: string;
  display_name: string;
  logo_url: string;
  tooltip: string;
  tooltip_prefix?: string;
  tooltip_suffix?: string;
  bottom_message?: string;
  fee: string;
  max_amount: string | null;
  min_amount: string | null;
  order: number;
  type: string;
  show_grouped: boolean;
  feature_flag_status: IFeatureFlagLogType;
  highlight: boolean;
  subtitle?: string | null;
  group_section_title?: string;
  group_section_subtitle?: string | null;
  group_drill_title?: string;
  created: string;
  modified: string;
  created_by: number | null;
  modified_by: number | null;
}

export interface IGlobalWarning {
  disabled: boolean | null;
  title: string | null;
  banner: string | null;
  disabled_end: string | null;
  offer_extension: boolean;
}

export type IProvidersResponse = IPaginatedResponse<IPaymentProviderBackend> & {
  global_warning: IGlobalWarning | null;
};
